export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["min"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Comprar"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["por"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ativo"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Link do anúncio"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID do maker"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descrição"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tempo limite"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Data de criação"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vou pagar"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vou receber"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Limite da negociação"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todos"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Negociações"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID da oferta"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Taxa"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selecionar conta"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fora do limite"])}
}